import { URL } from "../../api/Api";
import { catchError, GET, POST } from "../axios/Axios";

export const KlarityFileUpload = async (payload) => {
  try {
    const response = await POST(
      `${URL}/customers/klarity/file-upload`,
      payload
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const KlarityFileUploadData = async () => {
  try {
    const response = await GET(`${URL}/customers/klarity/file-upload`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};
